import { createAction, props } from '@ngrx/store';
import { CurrencyRatesOutput } from 'core/http/lg-logistic-rest-api/Auth/project.service';

export const getCurrencies = createAction('[Currencies Request] Get Currencies');
export const saveCurrencies = createAction('[Currencies State] Save Currencies In State', props<{ currencies: CurrencyRatesOutput }>());
export const markCurrenciesLoaded = createAction('[Currencies State] Mark Currencies Loaded');
